class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0, null, null, event.target);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';

    if(event.target.classList.contains('assembly-checkbox')) {
      this.handleAssemblyToggle(event.target);
      return;
    }

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId,
        event.target
      );
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      // {
      //   id: 'cart-icon-bubble',
      //   section: 'cart-icon-bubble',
      //   selector: '.shopify-section',
      // },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId, target) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    let giftVariantId = target.closest('tr.cart-item')?.dataset?.freeGiftVariantInCartId;
    let assemblyAddonLineItemId = target.closest('tr.cart-item')?.dataset?.assemblyAddonLineItemId;
    let giftVariantError;
    let assemblyAddonError;

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then(async(state) => {
        let newState = state;

        if(giftVariantId) {
          let _totalQuantity = 0;

          // Get total quantity of products eligible for free gift in cart
          const _parseCartState = JSON.parse(state);
          if(_parseCartState?.sections?.['cart-drawer']) {
            const _cartDrawerState = _parseCartState?.sections?.['cart-drawer'];
            const _cartDrawerHTML = new DOMParser().parseFromString(_cartDrawerState, 'text/html');
            _cartDrawerHTML.querySelectorAll(`tr.cart-item[data-free-gift-variant-in-cart-id="${giftVariantId}"]`).forEach((item) => {
              _totalQuantity += parseInt(item?.dataset?.quantity || 0);
            });
          }

          const updateGiftBody = JSON.stringify({
            id: giftVariantId,
            quantity: Math.max(quantity, _totalQuantity),
            sections: this.getSectionsToRender().map((section) => section.section),
            sections_url: window.location.pathname      
          });
          
          const updateGiftResponse = await fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body: updateGiftBody } })
          if (!updateGiftResponse.ok) {
            const error = await updateGiftResponse.text();
            const errors = JSON.parse(error)?.errors;
            giftVariantError = errors;
            console.error('Failed to update free gift variant in cart', errors);
          } else {
            const updateGiftText = await updateGiftResponse.text();
            newState = updateGiftText;  
          }
        }
        return newState;
      })
      .then(async(state) => {
        let newState = state;

        if(assemblyAddonLineItemId) {
          const updateAssemblyAddonBody = JSON.stringify({
            id: assemblyAddonLineItemId,
            quantity: quantity || 0,
            sections: this.getSectionsToRender().map((section) => section.section),
          });

          const updateAssemblyAddonResponse = await fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body: updateAssemblyAddonBody } });
          if (!updateAssemblyAddonResponse.ok) {
            const error = await updateAssemblyAddonResponse.text();
            const errors = JSON.parse(error)?.errors;
            assemblyAddonError = errors;
            console.error('Failed to update assembly add on product in cart', errors);
          } else {
            const updateAssemblyAddonText = await updateAssemblyAddonResponse.text();
            newState = updateAssemblyAddonText;
          }
        }

        return newState;
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        if (giftVariantError) {
          setTimeout(() => {
            document.querySelectorAll('.cart-item__error[data-variant-id="' + giftVariantId + '"]').forEach((errorText) => {
              const _errorTextContent = errorText?.querySelector('.cart-item__error-text');
              if (_errorTextContent) {
                _errorTextContent.textContent = giftVariantError;
              }
            });
          }, 1000);
        }

        if(assemblyAddonError) {
          setTimeout(() => {
            document.querySelectorAll('.cart-item__error[data-assembly-addon-line-item-id="' + assemblyAddonLineItemId + '"]').forEach((errorText) => {
              const _errorTextContent = errorText?.querySelector('.cart-item__error-text');
              if (_errorTextContent) {
                _errorTextContent.textContent = assemblyAddonError;
              }
            });
          }, 1000);
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch((e) => {
        console.error('Error updating quantity in cart', e);
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }

  async handleAssemblyToggle(checkbox) {
    checkbox.disabled = true;

    const isChecked = checkbox.getAttribute('data-checked') === 'true';
    const yesVariantId = checkbox.getAttribute('data-yes-variant-id');
    const noVariantId = checkbox.getAttribute('data-no-variant-id');
    const lineIndex = checkbox.getAttribute('data-line-index');
    const variantId = checkbox.getAttribute('data-item-variant-id');
    const productId = checkbox.getAttribute('data-product-id');
    const productTitle = checkbox.getAttribute('data-product-title');

    // Determine which variant to switch to
    const targetVariantId = isChecked ? noVariantId : yesVariantId;
    
    if (targetVariantId) {
      // This code was built by on the old logic, product has variant with option 'assembly required', 'yes' and 'no'
      try {
        // Disable checkbox during processing
        checkbox.disabled = true;
        const quantityInput = this.querySelector(`input[data-index="${lineIndex}"]`);
        const quantity = quantityInput ? parseInt(quantityInput.value) : 1;
          
        // Add new variant with same quantity
        const addBody = JSON.stringify({
          id: targetVariantId,
          quantity: quantity
        });
        
        const response = await fetch(`${routes.cart_add_url}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: addBody
        });
  
        if (!response.ok) {
          throw new Error('Failed to add new variant to cart');
        }
  
        // Remove current line item from cart
        const removeBody = JSON.stringify({
          id: variantId,
          quantity: 0
        });
  
        const removeResponse = await fetch(`${routes.cart_change_url}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: removeBody
        });
  
        if (!removeResponse.ok) {
          throw new Error('Failed to remove current line item from cart');
        }
  
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'checkbox-toggle' });
        
      } catch (error) {
        console.error('Error updating assembly option:', error);
        checkbox.checked = !isChecked; // Revert checkbox state
      } finally {
        // Re-enable checkbox
        checkbox.disabled = false;
      }  
    } else {
      // This code was built by on the new logic, product has variant with tag 'has-assembly-option'
      try {
        // Disable checkbox during processing
        checkbox.disabled = true;
        const quantityInput = this.querySelector(`input[data-index="${lineIndex}"]`);
        const eBikeQuantity = quantityInput ? parseInt(quantityInput.value) : 1;
          
        if(!isChecked && window.themeSettings.assembly_add_on_variant_id) {
          // Add assembly add on product to cart
          const addBody = JSON.stringify({
            id: window.themeSettings.assembly_add_on_variant_id,
            quantity: (eBikeQuantity || 0),
            properties: {
              'Assembled e-bike': `${productTitle}`,
              'Assembled e-bike ID': productId
            }
          });
          
          const response = await fetch(`${routes.cart_add_url}`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: addBody
          });        

          if (!response.ok) {
            throw new Error('Failed to add new variant to cart');
          }
        } else {
          const assemblyAddonLineItemId = checkbox.closest('tr.cart-item').getAttribute('data-assembly-addon-line-item-id');
          // Remove current line item from cart
          const removeBody = JSON.stringify({
            id: assemblyAddonLineItemId,
            quantity: 0,
          });
          
          const removeResponse = await fetch(`${routes.cart_change_url}`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: removeBody
          });
          
          if (!removeResponse.ok) {
            throw new Error('Failed to remove current line item from cart');
          }
        }
  
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'checkbox-toggle' });
        
      } catch (error) {
        console.error('Error updating assembly option:', error);
        checkbox.checked = !isChecked; // Revert checkbox state
      } finally {
        // Re-enable checkbox
        checkbox.disabled = false;
      }
    }
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
